import React from 'react';
import {
  BaseMixin,
  ElementaryMixin,
  NestingLevelMixin,
  ContentMixin,
  ColorSchemaMixin,
  Tools
} from './../common/common.js';
import Environment from '../environment/environment.js';

import './table-tfoot.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    ColorSchemaMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Table.TFoot',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection','smallBox'),
    classNames: {
      main: 'uu5-bricks-table-tfoot'
    },
    defaults: {
      childTagName: 'UU5.Bricks.Table.Tr',
      parentTagName: 'UU5.Bricks.Table'
    },
    opt: {
      nestingLevelMixin: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    allowTags: React.PropTypes.arrayOf(
      React.PropTypes.string
    )
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      allowTags: []
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  shouldChildRender_: function (child) {
    var childTagName = Tools.getChildTagName(child);
    var childTagNames = this.props.allowTags.concat(this.getDefault().childTagName);
    return childTagNames.indexOf(childTagName) > -1;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <tfoot {...this.buildMainAttrs()}>
          {this.getChildren()}
          {this.getDisabledCover()}
          </tfoot>
        ) : null
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/table-tfoot.js